var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.viewerType == "embeded"
    ? _c("embed-view", { attrs: { file: _vm.file } })
    : _vm.viewerType == "pdfjs"
    ? _c("pdf-viewer", { attrs: { id: _vm.id, file: _vm.file } })
    : _vm.viewerType == "iframe"
    ? _c("iframe-view", { attrs: { file: _vm.file } })
    : _vm.viewerType == "pdfObject"
    ? _c("objcet-view", { attrs: { file: _vm.file } })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }